var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("div", { staticClass: "boss-scout-confirm-container" }, [
        _c(
          "div",
          {
            staticClass: "boss-scout-confirm-header pega-break",
            attrs: { "data-test": "subject" },
          },
          [_vm._v("件名：" + _vm._s(_vm.subject))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "boss-scout-confirm-body pega-pre-wrap" }, [
          _c("div", { staticClass: "boss-scout-confirm-contents" }, [
            _c(
              "div",
              { staticClass: "boss-scout-confirm-contents-text clearfix" },
              [
                _c("div", {
                  staticClass:
                    "boss-scout-confirm-contents-sentence float-left pega-break",
                  attrs: { "data-test": "body" },
                  domProps: {
                    innerHTML: _vm._s(_vm.$sanitize(_vm.renderBody)),
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "boss-scout-confirm-bonus" },
              [
                _vm._l(_vm.specialFavorsMaster, function (specialFavor, i) {
                  return [
                    _vm.specialFavorIds.includes(specialFavor.id)
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: { content: specialFavor.description },
                                expression:
                                  "{ content: specialFavor.description}",
                              },
                            ],
                            key: i,
                            staticClass:
                              "boss-bonus-check-text boss-check-true",
                            attrs: { "data-test": "special-favor-id-" + i },
                          },
                          [_vm._v(_vm._s(specialFavor.name))]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.reservationDate
          ? _c("div", { staticClass: "boss-scout-confirm-footer" }, [
              _c("div", { attrs: { "data-test": "reservation-name" } }, [
                _vm._v(
                  "\n        スカウト送信予約名：" +
                    _vm._s(_vm.reservationName) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { attrs: { "data-test": "reservation-date" } }, [
                _vm._v(
                  "\n        送信日時：" +
                    _vm._s(_vm.reservationDate) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "form-button-area",
        [
          _c("form-back-button", {
            attrs: { "data-test": "back-button" },
            on: {
              back: function ($event) {
                return _vm.$emit("switching-state", true)
              },
            },
          }),
          _vm._v(" "),
          _c("form-confirm-button", {
            attrs: {
              "is-disabled": _vm.isScoutSendDisabled,
              "submit-label": _vm.reservationDate
                ? "この内容で送信予約をする"
                : "この内容で送信する",
              "data-test": "confirm-button",
            },
            on: {
              "submit-event": function ($event) {
                return _vm.$emit("register-scout-messages")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }